export default __webpack_public_path__ + "static/cover-img-2-7e43e897782c46cc863a52cd96007044.png";